import React, { useState, useEffect } from 'react';
import { Spinner, Button } from 'ui';
import AlertBox, { SubHeading } from 'components/shared/AlertBox';
import { routes, TYPES } from 'constants/config';
import request from 'utils/request_ajax';
import TriggersList from './TriggersList';
import TriggersHeader from './TriggersHeader';

const TriggersContainer = () => {
  const [triggers, setTriggers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [triggerToDeleteId, setTriggerToDelete] = useState(null);
  const [newTriggerType, setNewTriggerType] = useState(null);
  const [triggerFilter, setTriggerFilter] = useState(null);

  useEffect(() => {
    request.get(routes.TRIGGERS.INDEX).then(result => {
      setTriggers(result);
      setLoading(false);
    });
  }, []);

  const deleteTrigger = () => {
    request
      .delete(routes.TRIGGER(triggerToDeleteId))
      .then(() => {
        setTriggers(
          triggers.filter(trigger => trigger.id !== triggerToDeleteId),
        );
        setTriggerToDelete(null);
      })
      .fail(() => {
        setTriggerToDelete(null);
        // eslint-disable-next-line no-alert
        alert(t('common.server_error'));
      });
  };

  const confirmDelete = id => {
    setTriggerToDelete(id);
  };

  const cancelDelete = () => {
    setTriggerToDelete(null);
  };

  const addNewTrigger = type => {
    setNewTriggerType(type);
  };

  const addNewTriggerFilter = e => {
    if (e.target.value === '') {
      return setTriggerFilter(null);
    }
    return setTriggerFilter(e.target.value);
  };

  const receiveNewTrigger = trigger => {
    setTriggers([trigger, ...triggers]);
  };

  const receiveEditedTrigger = updatedTrigger => {
    const updatedTriggerIndex = triggers.findIndex(
      trigger => trigger.id === updatedTrigger.id,
    );

    const updatedTriggers = [...triggers];
    updatedTriggers[updatedTriggerIndex] = updatedTrigger;

    setTriggers(updatedTriggers);
  };

  const filteredTriggers = () => {
    if (triggerFilter) {
      return triggers.filter(
        // eslint-disable-next-line camelcase
        ({ assignee_name }) => assignee_name === triggerFilter,
      );
    }
    return triggers;
  };

  if (loading) {
    return <Spinner className="mb-24" />;
  }

  return (
    <div className="Triggers-container">
      <TriggersHeader
        newContentTrigger={() => addNewTrigger(true)}
        newGroupTrigger={() => addNewTrigger(TYPES.GROUP)}
        addNewTriggerFilter={e => addNewTriggerFilter(e)}
        triggerFilter={triggerFilter}
        triggers={triggers}
      />
      <TriggersList
        newTriggerType={newTriggerType}
        cancelAddNewTrigger={() => setNewTriggerType(null)}
        receiveNewTrigger={receiveNewTrigger}
        receiveEditedTrigger={receiveEditedTrigger}
        triggers={filteredTriggers()}
        confirmDelete={confirmDelete}
      />
      {triggerToDeleteId && (
        <AlertBox onDismiss={cancelDelete}>
          <SubHeading children={t('triggers.confirm_destroy')} />
          <div className="d-f jc-e ai-c mt-24">
            <button
              type="button"
              className="u-linkBtn u-linkBtn--dark td-u mr-16"
              onClick={cancelDelete}
              children={t('common.cancel')}
            />
            <Button
              primary
              onClick={deleteTrigger}
              children={t('common.delete')}
            />
          </div>
        </AlertBox>
      )}
    </div>
  );
};

export default TriggersContainer;
